const p = {
  projectKey: 'pay-defer',
  commitId: 'f0fc5a0b855a072d4ff147e8d9bf5ec7b0698b03',
  timestamp: '4/1/2025, 3:36:48 PM',
  commitMessage: '次卡接入先用后付-zhangsiwei02发起PR-pipeline增加埋点 -zhangsiwei02发起PR-pipeline feat:埋点 ------ PR Link: https://dev.sankuai.com/code/repo-detail/payfe/pay-defer/pr/179------PR Link: https://dev.sankuai.com/code/repo-detail/payfe/pay-defer/pr/181',
};
console.log('projectInfo:', p);
export default p;
